/*eslint-disable*/
import {
  GET_SECTIONS,
  SAVE_SURVEY,
  UPDATE_SURVEY,
  GET_ENUMS,
  UPDATE_ENUMS,
  GET_ENUMS_FILTERED,
  GET_SPECIFIC_STRUCTURE,
  PUT_SPECIFIC_STRUCTURE,
} from "../actionTypes";
import axios from "axios";
import { API_URI, envHost, loginUri, URL_SERVICE_PERSON } from "../../uri";
import Cookies from "js-cookie";
import i18n from "../../i18n.js";
import { toast } from "react-toastify";

export const getSections =
  (party: string) =>
  async (
    dispatch: (arg0: { type: any; payload: any; sort_sections: any }) => void
  ) => {
    try {
      const res = await axios.get(
        `${API_URI}/` + `${party}/sections/full-structure?includeNonVisibleQuestions=true`
      );
      let sort_sections: any = [];
      const sort = (o: any) => {
        let b: any = {};

        if (o.questions || o.subSection) {
          b["label"] = i18n.t(o["label"]);
          b["value"] = o["id"];
          b["children"] = [];
          b["children"].push(
            ...o.questions.map((e: any) => sort(e)),
            ...o.subSection.map((e: any) => sort(e))
          );
        } else {
          b["label"] = i18n.t(o["label"]);
          b["value"] = o["id"];
        }

        return b;
      };
      sort_sections = res.data.map((k: any) => sort(k));
      dispatch({
        type: GET_SECTIONS,
        payload: res.data,
        sort_sections: sort_sections,
      });
    } catch (e) {
      if (e.response && e.response.status === 401) {
        Cookies.remove("authToken");
        Cookies.remove("accessToken");
        window.location.href = `${loginUri}${envHost}`;
      }
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

export const updateEnums =
  (country: string) =>
  async (dispatch: (arg0: { type: any; payload: any }) => void) => {
    try {
      const res = await axios.get(
        `${URL_SERVICE_PERSON}service-person/v2/enum/legal-forms?customerType=COMPANY&country=${country}`
      );
      dispatch({
        type: UPDATE_ENUMS,
        payload: res.data,
      });
    } catch (e: any) {
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

export const getEnums =
  () => async (dispatch: (arg0: { type: any; payload: any }) => void) => {
    try {
      const res = await axios.get(
        `${URL_SERVICE_PERSON}service-person/v2/enum/all`
      );
      dispatch({
        type: GET_ENUMS,
        payload: res.data,
      });
    } catch (e) {
      if (e.response.status === 401) {
        Cookies.remove("authToken");
        Cookies.remove("accessToken");
        window.location.href = `${loginUri}${envHost}`;
      }
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

export const getEnumsFiltered =
  () =>
  async (dispatch: (arg0: { type: any; payload: any }) => void) => {
    try {
      const res = await axios.get(
        `${URL_SERVICE_PERSON}service-person/v2/enum/all?filter=false`
      );
      dispatch({
        type: GET_ENUMS_FILTERED,
        payload: res.data,
      });
    } catch (e) {
      if (e.response.status === 401) {
        Cookies.remove("authToken");
        Cookies.remove("accessToken");
        window.location.href = `${loginUri}${envHost}`;
      }

      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

export const updateSurvey =
  (surveys: any) =>
  async (dispatch: (arg0: { type: string; payload: any }) => void) => {
    try {
      dispatch({
        type: UPDATE_SURVEY,
        payload: surveys,
      });
    } catch (e) {
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

export const saveSurvey =
  (surveys: any) =>
  async (dispatch: (arg0: { type: any; payload: any }) => void) => {
    try {
      const section = surveys.sections;
      const res = await axios.put(
        `${API_URI}/${window.location.href.substring(
          window.location.href.lastIndexOf("/") + 1
        )}/sections/full-structure`,
        surveys.sections
      );

      dispatch({
        type: SAVE_SURVEY,
        payload: surveys.sections,
      });
      toast.success(i18n.t("SUCCESS"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (e) {
      if (e.response.status === 401) {
        Cookies.remove("authToken");
        Cookies.remove("accessToken");
        window.location.href = `${loginUri}${envHost}`;
      }

      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

export const getSpecificQuestionnaire =
  (isinCode: any) =>
  async (dispatch: (arg0: { type: any; payload: any }) => void) => {
    try {
      const res = await axios.get(
        `${URL_SERVICE_PERSON}service-person/v1/persons/client/fund/parts/${isinCode}/full-structure?includeNonVisibleQuestions=true`
      );
      dispatch({
        type: GET_SPECIFIC_STRUCTURE,
        payload: res.data,
      });
    } catch (e) {
      if (e.response.status === 401) {
        Cookies.remove("authToken");
        Cookies.remove("accessToken");
        window.location.href = `${loginUri}${envHost}`;
      }
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

export const putSpecificQuestionnaire =
  (Surveys: any, partId: any) =>
  async (dispatch: (arg0: { type: any; payload: any }) => void) => {
    try {
      const res = await axios.put(
        `${URL_SERVICE_PERSON}service-person/v1/persons/client/${partId}/fund/questions`,
        Surveys
      );
      dispatch({
        type: PUT_SPECIFIC_STRUCTURE,
        payload: res.data,
      });
      toast.success(i18n.t("SUCCESS"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (e) {
      if (e.response.status === 401) {
        Cookies.remove("authToken");
        Cookies.remove("accessToken");
        window.location.href = `${loginUri}${envHost}`;
      }
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };


export const handleDelete =
  async (questionId: string, party: string) => {
    try {
      const res = await axios.delete(
        `${API_URI}/${party}/questions/${questionId}`
      );
      toast.success(i18n.t("SUCCESS"), {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
        // @ts-ignore
      document.getElementById(questionId).remove();
    } catch (e) {
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    };
  };
